import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import { usePetitionSettingsPageData } from 'src/app/pages/petitionEditV2/pageContext';

import { useReopenPetitionModal } from './useReopenPetitionModal';

export function useReopenPetition() {
	const track = useTracking();
	const settingsData = usePetitionSettingsPageData();
	const {
		petition: {
			id: petitionId,
			signatureState: {
				signatureCount: { displayed: signatureCount },
			},
		},
	} = settingsData.data;
	const { refreshData } = settingsData.actions;

	const reopenPetition = useReopenPetitionModal();

	const handleReopenPetition = useCallback(async () => {
		void track('petition_settings_reopen_petition_button_click', { petition_id: petitionId });
		const modalResult = await reopenPetition({ petitionId, trackingData: { signatureCount } }).waitForResult();
		if (modalResult?.status === 'ok') refreshData();
	}, [reopenPetition, petitionId, refreshData, signatureCount, track]);

	return { actions: { handleReopenPetition } };
}
